import types from './types'
import globaltypes from '../globaltypes'
import auth from '../../services/AuthService'
import { $t } from '../../plugins/VueI18n'
import router from '../../router'
import { isMobileApp } from '../../helpers/platform'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  [types.actions.setLocale]: (context, locale) => {
    context.commit(types.mutations.setLocale, locale)
  },
  [types.actions.confirmSignIn]: (context, userData) => {
    context.dispatch(globaltypes.main.actions.setInformation, $t('login.welcome', { name: userData.name }))
    context.commit(types.mutations.set, userData)
    context.dispatch(types.actions.saveUser, userData)
    context.dispatch(globaltypes.crops.actions.fill)
    context.dispatch(globaltypes.main.actions.fill)
    router.push({ name: 'calendar' })
  },
  [types.actions.tryAutoSignIn]: (context, user) => {
    auth.wordpressAutoLogin().then(res => {
      console.log('auto login', res)
    })
  },
  [types.actions.signIn]: async (context, user) => {
    try {
      let userData
      let res = await auth.wordpressLogin({ username: user.username, password: user.password })
      userData = {
        id: res.data.email,
        name: res.data.displayName
      }
      await firebase.auth().signInWithCustomToken(res.data.token)
      await firebase.auth().currentUser.updateEmail(userData.id)
      context.dispatch(types.actions.confirmSignIn, userData)
    } catch (err) {
      var res = err.response ? err.response.data : err
      var message = res && res.message ? res.message : $t('login.cannot_login_using_wordpress')
      if (res) {
        switch (res.code) {
          case 'auth/account-exists-with-different-credential':
            message = $t('login.account_already_exists')
            break
          case 'auth/custom-token-mismatch':
            message = $t('login.server_error')
            break
        }
      }
      context.dispatch(globaltypes.main.actions.setInformation, message)
      throw res
    }
  },
  [types.actions.register]: (context, user) => {
    auth.registerNewUser({
      email: user.email,
      password: user.password,
      firstName: user.firstname,
      lastName: user.lastname
    }).then(res => {
      var userData = {
        username: res.data.username,
        password: user.password
      }
      context.dispatch(types.actions.signIn, userData)
    }).catch(err => {
      context.dispatch(globaltypes.main.actions.setInformation, (err.response.data.message || err.response.data))
    })
  },
  [types.actions.signInWithFacebook]: async context => {
    var provider = new firebase.auth.FacebookAuthProvider()
    try {
      let res
      if (isMobileApp()) {
        await firebase.auth().signInWithRedirect(provider)
        res = await firebase.auth().getRedirectResult()
      } else {
        res = await firebase.auth().signInWithPopup(provider)
      }
      const userData = {
        id: res.user.email,
        name: res.user.displayName
      }
      res = await auth.facebookLogin(res.credential.accessToken)
      context.dispatch(types.actions.confirmSignIn, userData)
    } catch (err) {
      firebase.auth().signOut()
      var message = err && err.message ? err.message : $t('login.cannot_login_using_facebook')
      if (err && err.code === 'auth/account-exists-with-different-credential') {
        message = $t('login.account_already_exists')
      }
      context.dispatch(globaltypes.main.actions.setInformation, message)
      throw err
    }
  },
  [types.actions.signInWithApple]: async context => {
    try {
      const provider = new firebase.auth.OAuthProvider('apple.com')
      provider.addScope('email')
      provider.addScope('name')
      provider.setCustomParameters({ locale: context.state.locale })
      await firebase.auth().signInWithRedirect(provider)
      let res = await firebase.auth().getRedirectResult()
      const userData = {
        id: res.user.email,
        name: res.user.displayName
      }
      res = await auth.appleLogin(res.credential.idToken)
      context.dispatch(types.actions.confirmSignIn, userData)
    } catch (err) {
      firebase.auth().signOut()
      var message = err && err.message ? err.message : $t('login.cannot_login_using_apple')
      if (err && err.code === 'auth/account-exists-with-different-credential') {
        message = $t('login.account_already_exists')
      }
      context.dispatch(globaltypes.main.actions.setInformation, message)
    }
  },
  [types.actions.loadUser]: async (context, email) => {
    const res = await firebase.firestore().collection('users').doc(email).get()
    if (!res.data()) return false
    const user = {
      id: res.id,
      name: res.data().name
    }
    context.commit(types.mutations.set, user)
    return true
  },
  [types.actions.saveUser]: async (context, user) => {
    await firebase.firestore().collection('users').doc(user.id).set({
      lastloggedin: new Date(),
      name: user.name,
      locale: context.state.locale
    })
  },
  [types.actions.signOut]: context => {
    firebase.auth().signOut()
    context.commit(types.mutations.set, false)
    context.dispatch(globaltypes.main.actions.clearSession, false)
    context.dispatch(globaltypes.main.actions.setInformation, $t('login.logged_out'))
  }
}
